import { Extension } from "@tiptap/core";

import FontSizeMenuButton from "./components/FontSizeMenuButton";
import { ensureNameValueOptions } from "../../utils/utils";
import { DEFAULT_FONT_SIZE_LIST, DEFAULT_FONT_SIZE_VALUE } from "../../constants";

export const FontSize = Extension.create({
	name: "fontSize",
	addOptions() {
		return {
			...this.parent?.(),
			types: ["textStyle"],
			fontSizes: [...DEFAULT_FONT_SIZE_LIST],
			button({ editor, extension, t }) {
				const fontSizes = ensureNameValueOptions(
					extension.options?.fontSizes || DEFAULT_FONT_SIZE_VALUE
				);
				const defaultFontSize = ensureNameValueOptions([DEFAULT_FONT_SIZE_VALUE])[0];
				const items = fontSizes.map(k => ({
					title:
						k.value === defaultFontSize.value
							? t("editor.fontSize.default.tooltip")
							: String(k.name),
					isActive: () => {
						const { fontSize } = editor.getAttributes("textStyle");
						const isDefault = k.value === defaultFontSize.value;
						const notFontSize = fontSize === undefined;
						if (isDefault && notFontSize) {
							return true;
						}
						return editor.isActive({ fontSize: String(k.value) }) || false;
					},
					action: () => {
						if (k.value === defaultFontSize.value) {
							editor.commands.unsetFontSize();
							return;
						}
						editor.commands.setFontSize(String(k.value));
					},
					divider: k.value === defaultFontSize.value || false,
					default: k.value === defaultFontSize.value || false
				}));
				const disabled = items.filter(k => k.disabled).length === items.length;
				return {
					component: FontSizeMenuButton,
					componentProps: {
						editor,
						tooltip: t("editor.fontSize.tooltip"),
						disabled,
						items,
						maxHeight: 280
					}
				};
			}
		};
	},
	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					fontSize: {
						default: null,
						parseHTML: element => element.style.fontSize.replaceAll(/["']+/g, ""),
						renderHTML: attributes => {
							if (!attributes.fontSize) {
								return {};
							}
							return {
								style: `font-size: ${attributes.fontSize}`
							};
						}
					}
				}
			}
		];
	},
	addCommands() {
		return {
			setFontSize:
				fontSize =>
				({ chain }) => {
					return chain().setMark("textStyle", { fontSize }).run();
				},
			unsetFontSize:
				() =>
				({ chain }) => {
					return chain()
						.setMark("textStyle", { fontSize: null })
						.removeEmptyTextStyle()
						.run();
				}
		};
	}
});
